import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { CompletedCollectionTransacitons } from "../../../../components/DirectDeposit/Transactions/CompletedCollection";

export interface ICompletedCollectionTransacitonsPage { }

export const completedCollectionTransacitonsPage: FC<ICompletedCollectionTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Completed Collection"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<CompletedCollectionTransacitons />}
		/>
	);
};
